import React from 'react';
import { useUserReviews } from '@/scopes/products/user-reviews/hooks';
import { List } from './List';
import { Heading } from './Heading';
import { Filters } from '../Filters/Filters';
import { styled } from 'styled-components';

const Wrapper = styled.div``;

export function Result() {
  const { isLoading } = useUserReviews();

  if (isLoading) {
    return 'Loading...';
  }

  return (
    <Wrapper>
      <Heading />
      <Filters />
      <List />
    </Wrapper>
  );
}

Result.Wrapper = Wrapper;
